import { render } from "./DashboardCompanyPage.vue?vue&type=template&id=dabb5c7c"
import script from "./DashboardCompanyPage.vue?vue&type=script&lang=js"
export * from "./DashboardCompanyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__